import { PORTAL_API_URL } from '../constants'

export const ENDPOINTS_V2 = {
  SUBJECTS: {
    getSubjectAssignments: (projectId, subjectId) => {
      return PORTAL_API_URL + `/v2/projects/${projectId}/subjects/${subjectId}/assignments`
    },
  },
} as const
